var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEgypt2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Egypt@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-70.000000, -682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Egypt"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 612.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bolivia-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.28,7.47 L0.28,16.47 L70.28,16.47 L70.28,7.47 C70.28,3.80282926 67.3071707,0.83 63.64,0.83 L6.93,0.83 C5.16723053,0.827345224 3.47575038,1.52574249 2.22834517,2.7712719 C0.980939967,4.01680131 0.279998001,5.70722853 0.28,7.47 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "0.28 32.18 70.28 32.18 70.28 16.51 0.28 16.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.28,41.19 C0.28,44.8571707 3.25282926,47.83 6.92,47.83 L63.64,47.83 C67.3071707,47.83 70.28,44.8571707 70.28,41.19 L70.28,32.19 L0.28,32.19 L0.28,41.19 Z",
    id: "Shape",
    fill: "#434A54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.87,19.8 L37,18.6 C36.868872,18.439834 36.6766539,18.3419115 36.47,18.33 L34.37,18.33 L33.67,22.13 L36.9,22.13 L36.47,19.8 L37.87,19.8 Z M37.57,30.33 L40.79,22.13 L29.79,22.13 L33,30.32 L37.57,30.32 L37.57,30.33 Z",
    id: "Shape",
    fill: "#FFCE54"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt2X);
export default __webpack_public_path__ + "static/media/Egypt@2x.52605848ac9e2f27e47ba1b936b9a987.svg";
export { ForwardRef as ReactComponent };